<button (click)="addField()" type="button" class="rounded" mdbBtn color="secondary" mdbWavesEffect>Add New Field</button>

<form [formGroup]="triggersService._dynamicFieldForm">
  <div class="card m-3">
      <div *ngFor="let field of triggersService.fields.controls; let i = index" class="list-group list-group-flush">
        <div class="row remove-bottom-margin">
          <div class="col-md-11 left-col">
            <div class="list-group-item">
              <div [formGroup]="field" class="form-row">
                <!-- First Column  -->
                <div class="col-md-4">
                  <div class="md-form remove-vertical-margin">
                    <mdb-select
                      [options]="_contactFieldsDropdown"
                      [filterEnabled]="true"
                      [visibleOptions]="10"
                      label="Contact Value"
                      formControlName="name"
                      (selected)="contactValueSelected($event, field)">
                    </mdb-select>
                  </div>
                </div>

                <!-- Second Column -->
                <div *ngIf="field.get('name').value" class="col-md-4">
                  <div *ngIf="!field.get('dateTime').value" class="md-form remove-vertical-margin">

                    <mdb-select
                      [options]="_updateTypes"
                      [filterEnabled]="true"
                      [visibleOptions]="10"
                      label="Update Type"
                      formControlName="updateType">
                    </mdb-select>
                  </div>
                  <div *ngIf="field.get('dateTime').value" class="md-form remove-vertical-margin">
                    <mdb-select
                      [options]="_updateTypesWithDate"
                      [filterEnabled]="true"
                      [visibleOptions]="10"
                      label="Update Type"
                      formControlName="updateType">
                    </mdb-select>
                  </div>
                </div>

                <!-- Third Column -->
                <div *ngIf="field.get('updateType').value" class="col-md-4">
                  <div *ngIf="field.get('updateType').value === 'RawValue'">
                    <div [ngSwitch]="field.get('controlType').value">
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.Input">
                          <input type="{{field.get('inputType').value}}"
                              mdbInput
                              formControlName="argument"
                              class="form-control"
                              onwheel="this.blur()"
                          />
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.Textarea">
                        <textarea
                            mdbInput
                            class="form-control md-textarea"
                            formControlName="argument"
                          >
                        </textarea>
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.Dropdown">
                        <mdb-select
                          formControlName="argument"
                          [options]="triggersService.multipleOptions[i]"
                          [visibleOptions]="10"
                        >
                        </mdb-select>
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.Checkbox">
                        <mdb-checkbox *ngFor="let option of triggersService.multipleOptions[i]; let i = index"
                          [inline]="true"
                          (change)="onCheckChange($event, field)"
                          [value]="option.value"
                          [checked]="option.checked"
                          >
                          {{option.label}}
                        </mdb-checkbox>
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.RadioButton">
                        <div class="form-check form-check-inline" *ngFor="let option of triggersService.multipleOptions[i]; ">
                          <input
                            type="radio"
                            class="form-check-input"
                            id="radio-{{option.value[0]}}"
                            name="argument"
                            formControlName="argument"
                            [value]="option.value[1]">
                        <label class="form-check-label" for="radio-{{option.value[0]}}">{{option.label}}</label>
                        </div>
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.DatePicker">
                        <input
                        mdbInput
                        type="date"
                        class="form-control"
                        formControlName="argument">
                      </div>
                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.TimePicker">
                        <input
                        mdbInput
                        type="time"
                        class="form-control"
                        formControlName="argument">
                      </div>

                      <div class="md-form remove-vertical-margin" *ngSwitchCase="_listControlTypeEnum.DateTimePicker">
                        <input
                        mdbInput
                        type="datetime-local"
                        class="form-control"
                        formControlName="argument">
                      </div>
                    </div>
                  </div>
                  <div *ngIf="field.get('updateType').value === 'FieldName'">
                    <div class="md-form remove-vertical-margin">
                      <mdb-select
                        [options]="_contactFieldsDropdown"
                        [filterEnabled]="true"
                        [visibleOptions]="10"
                        label="Contact Value"
                        formControlName="argument">
                      </mdb-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-1 text-center text-dark right-col">
            <mdb-icon (click)="removeField(i)" fas icon="trash" class="delete-icon" size="lg"></mdb-icon>
          </div>
        </div>
      </div>
      <div *ngIf="this._sameValueSelected">
        <div class="alert alert-warning remove-padding text-center">Duplicate Fields Selected. This will break the trigger if saved. Please Change.</div>
      </div>
  </div>
</form>
